import React, { useState } from 'react';
import styles from '../emergencyAlert.module.css';
import AIEduDialog from '../../../components/Dialog/AIEduDialog';
import AIEduButton from '../../../components/Button/AIEduButton';
import TagInfo from './TagInfo';
import RegenerateKeyDialog from './RegenerateKeyDialog';

const TagManagementPopup = ({
    visible,
    onHide,
    onConfirm,
    initialTags,
    loading,
    f,
    webhookUrl,
    apiKey,
    onWebhookUrlChange,
    onApiKeyChange,
    isEditMode = false,
}) => {
    const [showRegenerateKeyDialog, setShowRegenerateKeyDialog] = useState(false);
    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
    };

    const copyWebhookUrl = () => {
        copyToClipboard(webhookUrl || '');
    };

    const copyApiKey = () => {
        copyToClipboard(apiKey || '');
    };

    const handleRegenerateApiKey = () => {
        setShowRegenerateKeyDialog(true);
    };

    const handleRegenerateKeyConfirm = () => {
        // Here you would typically call an API to regenerate the key
        // For now, we'll just close the dialog and the parent can handle the actual regeneration
        setShowRegenerateKeyDialog(false);
        // You might want to call a prop like onRegenerateApiKey here
    };

    const handleRegenerateKeyCancel = () => {
        setShowRegenerateKeyDialog(false);
    };

    const handleDone = () => {
        // Simply close the popup when Done is clicked
        onHide();
    };

    return (
        <>
            <AIEduDialog
                visible={visible}
                draggable={false}
                style={{ width: '30vw', minWidth: '45rem' }}
                content={
                    <>
                        <div className={styles.popUpBtnContainer}>
                            To configure API connector, you will need below
                            information:
                        </div>
                        <div className='mt-4'>
                        <TagInfo
                            copyWebhookUrl={copyWebhookUrl}
                            webhookUrl={webhookUrl}
                            apiKey={apiKey}
                            copyApiKey={copyApiKey}
                            onRegenerateApiKey={handleRegenerateApiKey}
                            isEditMode={isEditMode}
                        />
                        </div>
                        <div
                            className='mt-4'
                            style={{ fontFamily: 'SamsungOne-600' }}
                        >
                            Instructions: <br />
                            You can quickly access the third-party platform via the
                            link below: <br />
                            InformaCast:{' '}
                            <a
                                href='https://admin.icmobile.singlewire.com/icmobile'
                                target='_blank'
                            >
                                https://admin.icmobile.singlewire.com/icmobile
                            </a>
                        </div>
                    </>
                }
                footer={
                    <div className='flex justify-content-center'>
                        <AIEduButton
                            label={f({ id: 'AI_EDU_DONE' })}
                            className='btnPrimary'
                            style={{ width: '5rem' }}
                            onClick={handleDone}
                            loading={loading}
                            disabled={loading}
                        />
                    </div>
                }
            />
            
            <RegenerateKeyDialog
                visible={showRegenerateKeyDialog}
                onHide={handleRegenerateKeyCancel}
                onConfirm={handleRegenerateKeyConfirm}
            />
        </>
    );
};

export default TagManagementPopup;
